import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const AD_CLIENT = "ca-pub-6638369212159081";
let settingsPromise;

export function useAdSettings() {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    settingsPromise = settingsPromise || api.get("/settings").then((r) => r.data).catch(() => ({}));
    settingsPromise.then(setSettings);
  }, []);
  return settings;
}

export function AdSlot({ type = "display", testid }) {
  const settings = useAdSettings();
  const pushed = useRef(false);
  const slot = type === "in-article" ? settings?.ad_slot_in_article : settings?.ad_slot_display;

  useEffect(() => {
    if (!slot || pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // ad blockers or duplicate pushes
    }
  }, [slot]);

  if (!slot) return null;
  const inArticle = type === "in-article";
  return (
    <div data-testid={testid} className="hh-ad not-prose my-8">
      <p className="text-[10px] uppercase tracking-[0.2em] text-[#5C5A56]/70 text-center mb-1">Advertisement</p>
      <ins
        className="adsbygoogle"
        style={{ display: "block", textAlign: inArticle ? "center" : undefined }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={slot}
        {...(inArticle
          ? { "data-ad-layout": "in-article", "data-ad-format": "fluid" }
          : { "data-ad-format": "auto", "data-full-width-responsive": "true" })}
      />
    </div>
  );
}
